module.exports = __webpack_public_path__ + "img/gr.51e5db2b.svg";